export default "__VITE_ASSET__Cim42QPp__"